import { SCREENS, REDUX_ACTIONS, GAME_ID } from '../../data/wordCityConstants';

const initialState = {
  currentScreen: SCREENS.LOADING,
  previousScreen: null,
};

const wordCityScreenReducer = (state = initialState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.CHANGE_SCREEN:
      return {
        currentScreen: payload,
        previousScreen: state.currentScreen,
      };
    default:
      return state;
  }
};

export default wordCityScreenReducer;
